module.exports = __webpack_public_path__ + "static/media/logo.65025d5d.png";